import { API_CALL } from 'actions/actionConstants'
import { AnyAppAction } from 'actions/types/ActionTypes'
import getApprovalRequestsForApprover from 'businessTraveller/api/getApprovalRequestsForApprover'
import { BUSINESS_TRAVELLER_API_ACTIONS } from 'reducers/businessTravellerApiActionReducers'
import { getChannelMarkup } from 'selectors/channelMarkupSelector'

function fetchMyApprovalQueue(
  businessId: string,
  employeeId: string,
  currentRegionCode: string,
  employees: Array<App.BusinessTraveller.EmployeeFromMeEndpoint>,
): AnyAppAction {
  return (dispatch, getState) => {
    const state = getState()

    const approveRequestExists = state.businessTraveller.approvalRequestsApprovals?.request && state.businessTraveller.approvalRequestsApprovals.request?.length > 0
    const channelMarkup = getChannelMarkup(state)

    if (!approveRequestExists) {
      dispatch({
        type: API_CALL,
        api: BUSINESS_TRAVELLER_API_ACTIONS.FETCH_APPROVAL_REQUEST_APPROVALS,
        request: () => getApprovalRequestsForApprover({
          businessId,
          channelMarkup,
          currentRegionCode,
          employeeId,
          employees,
        }),
      })
    }
  }
}

export default fetchMyApprovalQueue
